// extracted by mini-css-extract-plugin
module.exports = {"group":"da51a739f7--group--Ef8qI","group__item":"da51a739f7--group__item--quxzm"};